import React from 'react';
import Calendar from '../../../Components/Calendar/Calendar';
import { CONFERENCE } from '../../../Library/Variables';

const ConferenceCalendar = () => {
  return <Calendar type={CONFERENCE} />;
};

export default ConferenceCalendar;
